// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Flatlogic Dashboards (https://flatlogic.com/admin-dashboards)
 *
 * Copyright © 2015-present Flatlogic, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

 .root{
  margin-top: 130px;
  padding-left: 20px;
  padding-right: 20px;
}

/* Prevent horizontal scroll on dashboard page */
.root.dashboard {
  overflow-x: hidden;
}
 
 .usersTable {
   th,
   td {
     border-color: white;
   }
 
   thead {
     border-bottom: 1px solid #e9ecef; /* Assuming \$gray-200 is #e9ecef */
   }
 }


 .custom-widget {
  border: 1px solid #e7e5e5; /* Light gray border */
  border-radius: 5px; /* Rounded corners */
 
  background: #fff; /* Optional: Adds white background */
 
}



.custom-card {
  background-color: white;
  border: 1px solid #e7e5e5; /* Light gray border */
  border-radius: 5px; /* Rounded corners */
 

}



.widget-separator {
  border: 0;
  height: 1px;
  background-color: #616060; /* Light gray separator */
 
}

@media (max-width: 576px) {
  .dashboard h2 {
    font-size: 1.5rem;
  }
  
  .dashboard h5 {
    font-size: 1.1rem;
  }
  
  .dashboard h6 {
    font-size: 1rem;
  }
  
  .dashboard .card {
    padding: 0.75rem !important;
  }
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  display: block;
}

.styled-table {
  min-width: 600px;
  width: 100%;
}

/* Add these new styles */
.bg-white {
  width: 100%;

  overflow: hidden; /* Contains the floating elements */
}

@media (max-width: 768px) {
  .bg-white {
    margin: 0;
    padding: 1rem !important;
  }
}





.assessment-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 10px;
 
  margin: 0 auto;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.card-header h3 {
  font-size: 1.5rem;
  color: #2d3748;
  margin: 0;
}

.card-actions {
  display: flex;
  gap: 12px;
}

.btn-primary {
  background-color: #1f7c50;
  color: #fff;
  border: 1px solid #1f7c50;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary:hover {
  background-color: #196b43;
  border-color: #196b43;
  transform: translateY(-1px);
}

.btn-outline {
  background: transparent;
  color: #1f7c50;
  border: 1px solid #1f7c50;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-outline:hover {
  background-color: rgba(31, 124, 80, 0.08);
  border-color: #1f7c50;
  color: #1f7c50;
  transform: translateY(-1px);
}

.card-content {
  border-top: 1px solid #e2e8f0;
  padding-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;CAED;EACC,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;AACpB;;CAEC;GACE;;KAEE,mBAAmB;GACrB;;GAEA;KACE,gCAAgC,EAAE,kCAAkC;GACtE;CACF;;;CAGA;EACC,yBAAyB,EAAE,sBAAsB;EACjD,kBAAkB,EAAE,oBAAoB;;EAExC,gBAAgB,EAAE,oCAAoC;;AAExD;;;;AAIA;EACE,uBAAuB;EACvB,yBAAyB,EAAE,sBAAsB;EACjD,kBAAkB,EAAE,oBAAoB;;;AAG1C;;;;AAIA;EACE,SAAS;EACT,WAAW;EACX,yBAAyB,EAAE,yBAAyB;;AAEtD;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,WAAW;;EAEX,gBAAgB,EAAE,mCAAmC;AACvD;;AAEA;EACE;IACE,SAAS;IACT,wBAAwB;EAC1B;AACF;;;;;;AAMA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;;EAEb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB","sourcesContent":["/**\r\n * Flatlogic Dashboards (https://flatlogic.com/admin-dashboards)\r\n *\r\n * Copyright © 2015-present Flatlogic, LLC. All rights reserved.\r\n *\r\n * This source code is licensed under the MIT license found in the\r\n * LICENSE.txt file in the root directory of this source tree.\r\n */\r\n\r\n .root{\r\n  margin-top: 130px;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n}\r\n\r\n/* Prevent horizontal scroll on dashboard page */\r\n.root.dashboard {\r\n  overflow-x: hidden;\r\n}\r\n \r\n .usersTable {\r\n   th,\r\n   td {\r\n     border-color: white;\r\n   }\r\n \r\n   thead {\r\n     border-bottom: 1px solid #e9ecef; /* Assuming $gray-200 is #e9ecef */\r\n   }\r\n }\r\n\r\n\r\n .custom-widget {\r\n  border: 1px solid #e7e5e5; /* Light gray border */\r\n  border-radius: 5px; /* Rounded corners */\r\n \r\n  background: #fff; /* Optional: Adds white background */\r\n \r\n}\r\n\r\n\r\n\r\n.custom-card {\r\n  background-color: white;\r\n  border: 1px solid #e7e5e5; /* Light gray border */\r\n  border-radius: 5px; /* Rounded corners */\r\n \r\n\r\n}\r\n\r\n\r\n\r\n.widget-separator {\r\n  border: 0;\r\n  height: 1px;\r\n  background-color: #616060; /* Light gray separator */\r\n \r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .dashboard h2 {\r\n    font-size: 1.5rem;\r\n  }\r\n  \r\n  .dashboard h5 {\r\n    font-size: 1.1rem;\r\n  }\r\n  \r\n  .dashboard h6 {\r\n    font-size: 1rem;\r\n  }\r\n  \r\n  .dashboard .card {\r\n    padding: 0.75rem !important;\r\n  }\r\n}\r\n\r\n.table-responsive {\r\n  overflow-x: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n  width: 100%;\r\n  display: block;\r\n}\r\n\r\n.styled-table {\r\n  min-width: 600px;\r\n  width: 100%;\r\n}\r\n\r\n/* Add these new styles */\r\n.bg-white {\r\n  width: 100%;\r\n\r\n  overflow: hidden; /* Contains the floating elements */\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .bg-white {\r\n    margin: 0;\r\n    padding: 1rem !important;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.assessment-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\r\n  padding: 10px;\r\n \r\n  margin: 0 auto;\r\n}\r\n\r\n.card-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.card-header h3 {\r\n  font-size: 1.5rem;\r\n  color: #2d3748;\r\n  margin: 0;\r\n}\r\n\r\n.card-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.btn-primary {\r\n  background-color: #1f7c50;\r\n  color: #fff;\r\n  border: 1px solid #1f7c50;\r\n  padding: 10px 16px;\r\n  border-radius: 8px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background-color: #196b43;\r\n  border-color: #196b43;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.btn-outline {\r\n  background: transparent;\r\n  color: #1f7c50;\r\n  border: 1px solid #1f7c50;\r\n  padding: 10px 16px;\r\n  border-radius: 8px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.btn-outline:hover {\r\n  background-color: rgba(31, 124, 80, 0.08);\r\n  border-color: #1f7c50;\r\n  color: #1f7c50;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.card-content {\r\n  border-top: 1px solid #e2e8f0;\r\n  padding-top: 20px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
